import { Box } from "@mui/material";
import { Login } from "components/Login/Login";
import Footer from "components/Login/LoginFooter";
import { useMemo } from "react";
import { Helmet } from "react-helmet";

import "../App.css";
import logo from "../images/branding/orkes-logo-cloud.svg";

const getPageMetadata = (signup: boolean) => {
  if (signup) {
    return {
      pageTitle: "Sign Up | Orkes Cloud",
      metaDescription:
        "Sign up for the Orkes Cloud platform to manage and monitor your Conductor clusters.",
    };
  }
  return {
    pageTitle: " Log In | Orkes Cloud",
    metaDescription:
      "Log in to the Orkes Cloud platform to manage and monitor your Conductor clusters.",
  };
};

function LoginPage({ signup = false }: { signup: boolean }) {
  const { pageTitle, metaDescription } = useMemo(
    () => getPageMetadata(signup),
    [signup]
  );
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <Box className={"container"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 11,
          }}
        >
          <img src={logo} alt="logo" width="300px" />
        </Box>
        <main
          style={{
            overflowX: "hidden",
          }}
        >
          <Login signup={signup} />
        </main>
        <Footer />
      </Box>
    </>
  );
}

export default LoginPage;
